import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumb from "../common/breadcrumb";
import Helmet from "react-helmet";
import { auth_actions, global_actions } from "../../redux-store";
import backend from "../../api";
import { Notification } from "../../utils";
import Modal from "react-responsive-modal";
import axios from "axios";
import { Event } from "../Tracking/Tracking";

const Login = () => {
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
    getValues,
  } = useForm();
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [info, setInfo] = useState({ ip: "" });
  const [modal, setModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const redirectQuery = new URLSearchParams(location.search).get("redirect");

  const redirectPath =
    redirectQuery ||
    (user?.user?.role === "member"
      ? `/dashboard/${user?.user?.role}/account`
      : `/dashboard/${user?.user?.role}`);

  const email = watch("email");
  const password = watch("password");

  useEffect(() => {
    if (user) {
      setModal(true);
    }
  }, [user]);

  const URL = "https://ip.nf/me.json";
  useEffect(() => {
    axios.get(URL).then(({ data }) => {
      setInfo({ ...data });
    });
  }, []);

  useEffect(() => {
    if (user && user.role === "member" && user.ip_address !== info.ip.ip) {
      dispatch(auth_actions.logout());
      setOpen(true);
    }
  }, [user, info]);

  useEffect(() => {
    if (isSubmitting) {
      setIsSubmitting(false);
    }
  }, [email, password]);

  // useEffect(() => {
  //   if (modal && user) {
  //     setModal(false);
  //     history.replace(redirectPath);
  //   }
  // }, [user, redirectPath, modal, history]);

  const submitModal = () => {
    const val = getValues();
    const status = new Notification();
    dispatch(global_actions.loading(true));
    backend
      .post("/user/eksplodecode/signin", {
        password: val.password,
        eksplode_code: val.eksplode_code,
      })
      .then(({ data }) => {
        status.set_toast("success", data.message);
        status.show_toast();
        Event(`${data.data.role}`, "login", `Login ${data.data.role} by ip`);
        dispatch(global_actions.loading(false));
        sessionStorage.setItem("token", data.token);
        dispatch(auth_actions.login_by_token());
        backend
          .put(`/user/${data.data._id}`, {
            ip_address: info.ip.ip,
          })
          .then(({ data: { data, message } }) => {})
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
        dispatch(global_actions.loading(false));
        status.show_toast();
      });
    setOpen(false);
  };

  const loginHandler = () => {
    setIsSubmitting(true);
    const val = getValues();
    const eks_reg = /^[A-Z]{2,3}-[0-9]{10}(-(M|C|P))?$/;
    if (val.email.match(eks_reg)) {
      const status = new Notification();
      dispatch(global_actions.loading(true));
      backend
        .post("/user/eksplodecode/signin", {
          ...val,
          eksplode_code: val.email,
        })
        .then(({ data }) => {
          if (["admin", "star"].every((i) => i !== data.data.role)) {
            status.set_toast("success", data.message);
            status.show_toast();
            dispatch(global_actions.loading(false));
            sessionStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.data));
            dispatch(auth_actions.login_by_token());
            Event(`${data.data.role}`, "login", `Login ${data.data.role}`);
            history.replace(redirectPath);
          } else {
            status.set_toast("warn", "Admin and Star can't login here");
          }
        })
        .catch((error) => {
          status.set_toast(
            "error",
            error.response ? error.response.data.message : error.message
          );
          status.show_toast();
          dispatch(global_actions.loading(false));
          setIsSubmitting(false);
        });
    } else {
      dispatch(auth_actions.login(val, () => history.replace(redirectPath)));
      Event("Login", "login", "Normal Login");
      // history.replace(redirectPath);
    }
  };

  return (
    <div>
      <Helmet>
        <title>eksplode! | Login </title>
      </Helmet>
      <Breadcrumb title={"Login"} />
      {/*Login section*/}
      <section className="login-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h3>Login</h3>
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-group">
                    <label htmlFor="email">Email / eksplode! Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Email / eksplode! Code"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                        pattern: {
                          value: /^(?:[a-z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])|([A-Z]{2,3}-[0-9]{10}(-(M|C|P))?)$/,
                          message:
                            "This must be a valid Email or eksplode! Code",
                        },
                      })}
                    />
                    <label htmlFor="email" className="error">
                      {errors.email && errors.email.message}
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="review">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="review"
                      placeholder="Enter your password"
                      name="password"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="password" className="error">
                      {errors.password && errors.password.message}
                    </label>
                  </div>
                  <a
                    href="#"
                    className={`btn btn-solid ${
                      email && password && !isSubmitting ? "" : "disabled"
                    }`} // Disable button when email or password is empty
                    onClick={!isSubmitting ? handleSubmit(loginHandler) : null}
                  >
                    Login
                  </a>

                  <Link
                    className="px-3"
                    to={`${process.env.PUBLIC_URL}/forget-password`}
                  >
                    Forgot password?
                  </Link>
                </form>
              </div>
            </div>
            <div className="col-lg-6 right-login">
              <h3>Welcome</h3>
              <div className="theme-card authentication-right">
                <h6 className="title-font">Create A Account</h6>
                <p>
                  Sign up for a free account at our store. Registration is quick
                  and easy. It allows you to be able to order from our shop. To
                  start shopping click register.
                </p>
                <Link
                  to={`/register/customer?redirect=${encodeURIComponent(
                    redirectQuery || location.pathname + location.search
                  )}`}
                  className="btn btn-solid mb-3 mr-1"
                >
                  Register as Customer
                </Link>
                <Link to="/register/member" className="btn btn-solid mb-3">
                  Register as Member
                </Link>
                <Link
                  to="/register/merchant"
                  className="btn btn-solid mb-3 mr-1"
                >
                  Register as Retailer
                </Link>
                <Link to="/signup/brand" className="btn btn-solid mb-3">
                  Register as Brand
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {user && (
        <Modal
          open={modal}
          onClose={() => {
            if (user) {
              setModal(false);
              history.replace(redirectPath);
            }
          }}
          center
        >
          <div className="container px-5 pt-5">
            <div className="row">
              <h2>{user && user.eksplode_code}</h2>
              <p>
                Here is your eksplode! Code. You can use either this or your
                email to sign in
              </p>
            </div>
            <div className="row mt-3 ">
              <button
                className="btn btn-solid"
                onClick={() => {
                  setModal(false);
                  history.replace(redirectPath);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal>
      )}

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          history.replace(`${process.env.PUBLIC_URL}/login`);
        }}
        center
      >
        <div className="container px-5 pt-5 custom-modal">
          <div className="row">
            <h4>Signing in with different IP</h4>
          </div>
          <div className="row px-3">
            <p>
              Sorry, but our system cannot identify you. If you are an EAC
              Member using a different IP address
            </p>
          </div>
          <div className="form-row mr-3">
            <div className="col-md-6">
              <label htmlFor="eksplode_code">eksplode! Code</label>
              <input
                type="text"
                className="form-control mb-0 "
                id="eksplode_code"
                placeholder="Enter your Eksplode code"
                name="eksplode_code"
                ref={register({
                  required: {
                    value: true,
                    message: "This Field is Required",
                  },
                })}
              />
              <label htmlFor="eksplode_code" className="error">
                {errors.eksplode_code && errors.eksplode_code.message}
              </label>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="form-control mb-0"
                  id="review"
                  placeholder="Enter your password"
                  name="password"
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                  })}
                />
                <label htmlFor="password" className="error">
                  {errors.password && errors.password.message}
                </label>
              </div>
            </div>
          </div>
          <button
            className="btn btn-solid mt-2 justify-content-start"
            onClick={handleSubmit(submitModal)}
          >
            Submit
          </button>
          <Link
            className="px-3 py-3 ml-10 mt-20 justify-content-end"
            to={`${process.env.PUBLIC_URL}/forget-password`}
          >
            Forgot password?
          </Link>
        </div>
      </Modal>
    </div>
  );
};

export default Login;
